module.exports = __webpack_public_path__ + "img/banner_bg.90ad20f1.png";